import { rollUpImpl } from './rollup-impl.ts';

// The unplugin API is based on the rollup/rolldown APIs, so it
// should just be a compatible rolldown plugin.
export default rollUpImpl;
